// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-content,
.container__mainContent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f9f9f9;
  height: 100%;
}

.container__mainContent {
  padding: 1.5rem;
}

.main {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;;EAEI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AACA;EACI,YAAA;AAEJ","sourcesContent":[".main-content,\n.container__mainContent {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-color: #f9f9f9;\n    height: 100%;\n}\n\n.container__mainContent{\n    padding: 1.5rem;\n}\n.main {\n    height: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
